import React from "react";

import Lamina14img from "../images/lamina14img.png";
import Lamina14bullet from "../images/lamina14bullet.png";
import Lamina14text from "../images/lamina14text.png";
import Lamina14nota from "../images/lamina14nota.png";
import Lamina14act from "../images/lamina14act.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  blue: {
    color: theme.palette.blue.main,
    borderColor: theme.palette.blue.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
      marginBottom: "1em",
      listStyleType: "none",
      paddingLeft: "1.5em",
      backgroundImage: "url(" + Lamina14bullet + ")",
      backgroundSize: "1em",
      backgroundRepeat: "no-repeat",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
      "& ul": {
        paddingLeft: 0,
      },
    },
  },
  papel: {
    background: "#e6e7e8",
    padding: "1.5em",
    marginTop: -8,
    boxShadow: "-8px 9px 0px 0px rgba(0,0,0,0.3)",
    width: "90%",
    margin: "-8 auto 0",
  },
  blueBox: {
    background: theme.palette.blue.main,
    color: "#fff",
    padding: 10,
    textAlign: "center",
    fontWeight: 700,
    marginBottom: "1em",
  },
}));

const Lamina14 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 14: Derecho de los niños y las niñas"
        meta={[
          {
            property: "og:title",
            content: "Lámina 14: Derecho de los niños y las niñas",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Todas las niñas y niños son vulnerables y deben ser protegidos para evitar cualquier abuso, maltrato o injusticia. ",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="14" color="blue" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="flex-end"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Title title="DERECHOS DE LOS NIÑOS Y LAS NIÑAS" color="blue" />
            <p>
              Todas las niñas y niños son vulnerables y deben ser protegidos
              para evitar cualquier abuso, maltrato o injusticia. Ellos y ellas
              tienen derechos y lograr su cumplimiento es tarea de todos.
            </p>
            <br></br>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina14img} alt="La identidad" />
          </Grid>
        </Grid>
        <div className={classes.papel}>
          <div className={classes.blueBox}>
            Entre los más importantes están los derechos a:
          </div>
          <Grid container className={classes.root} spacing={1} justify="center">
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <ul className={classes.listDerechos}>
                <li>
                  No ser discriminado (todos los niños y las niñas tienen los
                  mismos derechos).
                </li>
                <li>Tener una familia que lo quiera y que lo cuide.</li>
                <li>Recibir educación escolar.</li>
                <li>
                  Recreación (disponer de espacio y tiempo para jugar, poder
                  hacerlo con juguetes).
                </li>
                <li>La vida, a la supervivencia y al desarrollo adecuado.</li>
              </ul>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <ul className={classes.listDerechos}>
                <li>
                  Participar y ser consultados sobre las situaciones que les
                  afecten, y a que sus opiniones sean tomadas en cuenta.
                </li>
                <li>
                  La vivienda digna (vivir en un espacio adecuado para su
                  desarrollo).
                </li>
                <li>
                  Que cualquier decisión, ley o política que pueda afectar a la
                  infancia considere qué es lo mejor para el niño.
                </li>
              </ul>
            </Grid>
          </Grid>
        </div>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <p>
              <strong>Conversa con alguien de tu familia:</strong>
            </p>
            <p>
              ¿Quiénes son las personas o instituciones que velan por el
              cumplimiento de estos derechos en el Perú o en tu localidad?
            </p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina14text} alt="Derechos niños" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="blue" />
        <p>
          <strong>
            Observa las imágenes y encierra en un círculo si se cumple o no se
            cumple alguno de los derechos de estos niños.
          </strong>
        </p>
        <img src={Lamina14act} alt="Actividad lámina 14" />
        <img src={Lamina14nota} alt="Lámina 14 nota" />
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-14.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.blue }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 14: Derecho de los niños y las niñas'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="La identidad y la importancia del DNI"
        anteriorEnlace="/lamina-1-13"
        siguiente="Normas de convivencia"
        siguienteEnlace="/lamina-1-15"
      />
    </>
  );
};

export default Lamina14;
